import { Player } from "../Model/Player";
export class PlayersFactory {
    createPlayer(id, identityOverride, name, pictureId, roomId) {
        return new Player(id, identityOverride, name, pictureId, roomId);
    }
    createPlayerFromDto(dto) {
        return this.createPlayer(dto.id, dto.identityOverride, dto.name, dto.pictureId, dto.roomId);
    }
}
